import { Select } from "antd";
import Caption from "../../../components/Typography/Caption";

export const ChartTypeSelector = ({
  value,
  onChange,
}: {
  value: "line" | "area" | "bar";
  onChange: (value: "line" | "area" | "bar") => void;
}) => {
  const chartTypes = [
    { value: "line", label: "Line" },
    { value: "bar", label: "Bar" },
    { value: "area", label: "Area" },
  ];

  return (
    <div className="flex items-center gap-2">
      <Caption className="text-[color:var(--vi-text)] font-dm font-semibold">
        Chart Type:
      </Caption>
      <Select
        value={value}
        style={{ width: 100 }}
        onChange={onChange}
        popupClassName="vi-dg-stock-popup"
        options={chartTypes.map((type) => ({
          value: type.value,
          label: <span>{type.label}</span>,
        }))}
      />
    </div>
  );
};
